import MyTable from "components/UIElements/MyTable";
import { useParams, useLocation } from "react-router-dom";
import  EndPoints from 'shared/endPoints/EndPoints.json';

export default function Messages() {

    const { id, } = useParams();
    const endPoint = `${EndPoints.CONTRACT.GETMESSAGES}/?id=${id}`;
    const location = useLocation();
    const exportFilename = `Anytime_BTM_SMS_EMAIL_History_Contract_${location.state.policyNumber}`;

    const columns = [
        {
            title: 'Αρ. Συμβολαίου',
            key: 'policyNumber',
            dataIndex: 'policyNumber'
        },
        {
            title: 'Ημερομηνία Αποστολής',
            key: 'dateCreated',
            dataIndex: 'dateCreated'
        },
        {
            title: 'Περιεχόμενο Μηνύματος',
            key: 'messageCode',
            dataIndex: 'messageCode'
        },
        {
            title: 'Τύπος Μηνύματος',
            key: 'messageType',
            dataIndex: 'messageType'
        },
        {
            title: 'Κατάσταση',
            key: 'status',
            dataIndex: 'status',
            render : (status) => {
                let context = '__';
                if(status === true){ context = 'Παραδόθηκε'}
                else if(status === false){ context = 'Δεν παραδόθηκε'}
                return context
            }   
        },
    ];

    return <MyTable columns={columns} endPoint={endPoint} exportFilename={exportFilename} ContractTab/>
}